import React from 'react';
import PovIndividualContributorOppsTable from './PovIndividualContributorOppsTable';
import PovActivityByOpportunity from './PovActivityByOpportunity';

interface Props {
  email: string;
  /** The time dropdown's `current_time_filter` (`all` or `range:...`); opportunities are kept by Close Date. */
  timeFilter?: string;
  /** The period in words (e.g. "This Fiscal Quarter"), for headings. */
  timeShort?: string;
  /** The fiscal calendar is still loading; hold the data until the window is known. */
  timePending?: boolean;
}

export default function PovIndividualContributorPage({
  email,
  timeFilter = 'all',
  timeShort,
  timePending = false,
}: Props) {
  return (
    <div className="w-full h-full min-h-0 flex flex-col gap-3" style={{ overflowY: 'auto' }}>
      <PovActivityByOpportunity email={email} timeFilter={timeFilter} timeShort={timeShort} timePending={timePending} />
      <div className="hbr-css__container-card p-3 w-full" style={{ height: 560, flexShrink: 0 }}>
        <div className="hbr-css__text-primary-sm-semibold mb-2">
          {timeShort && timeFilter !== 'all' ? `POV Opportunities \u2014 ${timeShort}` : 'POV Opportunities'}
        </div>
        <div style={{ height: 'calc(100% - 24px)', minHeight: 0 }}>
          <PovIndividualContributorOppsTable email={email} timeFilter={timeFilter} timePending={timePending} />
        </div>
      </div>
    </div>
  );
}
